module.exports = "<script type=\"text/html\" id=\"survey-question-empty\">\r\n    <div></div>\r\n</script>\r\n";